// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"133":"CalculatorPage","475":"MainPage","547":"DiaryPage","789":"LoginPage","846":"RegisterPage"}[chunkId] || chunkId) + "." + {"133":"45b4c3dc","475":"69566f92","547":"5576aed0","643":"d23a915e","664":"3a6e95f9","787":"05c20f71","789":"cfd09803","846":"484c2789"}[chunkId] + ".chunk.js";
};